import React, { FC, useEffect } from 'react';
import { ListItem, ListItemText, makeStyles } from '@material-ui/core';
import { RouteComponentProps, NavLink } from 'react-router-dom';
import ListDashboard, {ListDashboardProps} from 'Components/Dashboard/ListDashboard';
import { useDispatch, useSelector } from 'react-redux';
import { TDispatch } from 'Typings/Global';
import { ReduxStore } from 'stores';
import { User, UserState } from 'Models/Users/@types';
import useAsyncTask from 'hooks/useAsyncTask';
import { OUser } from 'Models/Users/Model';
import UserDetail from './UserDetail';
import UserComments from './UserComments';


const get_SUB_DASHBOARD_LINK_CONFIG = (): ListDashboardProps['contentConfig'] => ([
    {
        id: 'details',
        link: 'details',
        name: 'Details',
        component: UserDetail
    },
    {
        id: 'comments',
        link: 'comments',
        name: 'Comment',
        component: UserComments
    }
])


export interface UsersListProps extends RouteComponentProps<{ id: string }> { }
type StoreSelection = Pick<UserState, 'list'>;

const Users: FC<UsersListProps> = () => {

    const dispatch = useDispatch<TDispatch>();
    const getDataTask = useAsyncTask(async () => await dispatch(OUser.getItemsList({})));
    const { list =[] } = useSelector<ReduxStore, StoreSelection>(({ Users: { list } }) => ({ list }));
    const classes = useStyles();
    useEffect(() => {
        getDataTask.run();
        //eslint-disable-next-line
    }, []);
    const renderUserListItem = (item: User) => {
        const {firstName, lastName, id} = item;
        return (
            <NavLink key={id} to={`/dashboard/users/${id}/details`}>
                <ListItem className={classes.listAlignment}>
                    <ListItemText
                        primary={`${firstName} ${lastName}`}
                    />
                </ListItem>
            </NavLink>
        )
    }

    return (
        <ListDashboard 
            baseUrl={'/dashboard/users'}
            itemList={list}
            listProps={{searchProps: {}}}
            renderListItem={renderUserListItem}
            contentConfig={get_SUB_DASHBOARD_LINK_CONFIG()}
        />
    )
}

const useStyles = makeStyles((theme) => ({
    demo: {
        backgroundColor: theme.palette.background.paper,
        width: 300,
        height: 'calc(100vh - 140px)'
    },
    listAlignment: {
        borderBottom: '1px solid #d9d9d9',
        color: '#000'
    },
    profileImage: {
        width: 50,
        height: 50,
        objectFit: 'contain'
    },
    linkText: {
        color: '#000'
    }
}));
export default Users;